import styled from 'styled-components';

export const GeneralStudentStyleButton = styled.div`
  .button-primary {
    background-color: ${(props) => (props.theme.primary)} !important;
    color: #ffffff
  }

  .button-secondary {
    background-color: ${(props) => (props.theme.secondary)} !important;
    color: #ffffff
  }

  .button-terciario {
    background-color: ${(props) => (props.theme.buttonTerciario)} !important;
    color: #ffffff
  }

  .button-white {
    color: ${(props) => (props.theme.whiteButton)} !important;
  }
`;
